(function () {
    'use strict';

    angular
        .module('iMatApp')
        .controller('UploadedModelsController', UploadedModelsController);

    UploadedModelsController.$inject = ['$scope', '$uibModal', 'modelTabWorkflow'];

    function UploadedModelsController($scope, $uibModal, modelTabWorkflow) {
        var vm = this;
        
        vm.addFromUploadedModels = addFromUploadedModels;

        // ---------------------------------------------------------------------------------------------

        function addFromUploadedModels() {
            showUploadedModelsWindow()
               .then(function (modelId) {
                   if (modelId) {
                       modelTabWorkflow.selectModel(modelId);
                   }
               });
        }

        // ---------------------------------------------------------------------------------------------

        function showUploadedModelsWindow() {
            var modalWindow = $uibModal.open({
                templateUrl: '/Scripts/iMatApp/model/views/previouslyUploadedModelsWindowView.html',
                controller: 'PreviouslyUploadedModelsWindowController',
                controllerAs: 'windowViewModel',
                resolve: {
                    multiselect: false
                }
            });

            return modalWindow.result;
        }
    }
})();
